import { render, staticRenderFns } from "./ChoiceTypeDescriptionEdit.vue?vue&type=template&id=8b110d76&scoped=true"
import script from "./ChoiceTypeDescriptionEdit.vue?vue&type=script&lang=ts"
export * from "./ChoiceTypeDescriptionEdit.vue?vue&type=script&lang=ts"
import style0 from "./ChoiceTypeDescriptionEdit.vue?vue&type=style&index=0&id=8b110d76&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b110d76",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VHover } from 'vuetify/lib/components/VHover';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VHover,VRow})


/* vuetify-loader */
import installDirectives from "!../../../node_modules/vuetify-loader/lib/runtime/installDirectives.js"
import ClickOutside from 'vuetify/lib/directives/click-outside'
installDirectives(component, {ClickOutside})
